import React from 'react';

// outside click hook to dismiss open menus/trays when user clicks outside of them
export const useDismissOnOutsideClick = <T extends HTMLElement>(
    isOpen: boolean,
    onDismiss: () => void,
): React.RefObject<T> => {
    const containerRef = React.useRef<T>(null);

    React.useEffect(() => {
        if (!isOpen) {
            return;
        }

        const handlePointerDown = (event: MouseEvent | TouchEvent): void => {
            const target = event.target;

            if (!(target instanceof Node)) {
                return;
            }

            if (containerRef.current?.contains(target)) {
                return;
            }

            onDismiss();
        };

        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('touchstart', handlePointerDown);

        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('touchstart', handlePointerDown);
        };
    }, [isOpen, onDismiss]);

    return containerRef;
};

export default useDismissOnOutsideClick;
